
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"droparea-text":"Attribut hier ablegen","droparea.dragover.overlay":"Ablegen, um Attribut zu ersetzen","button.clearAll":"Alle Filter leeren","button.settings":"Einstellungen","reverseOrder":"Reihenfolge umkehren"},"en":{"droparea-text":"Drag attributes here","droparea.dragover.overlay":"Drop to replace attribute","button.clearAll":"Clear all filters","button.settings":"Settings","reverseOrder":"Reverse order"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();